import React from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { initializeIcons } from '@fluentui/react'

import Chat from './pages/chat/Chat'
import Layout from './pages/layout/Layout'
import NoPage from './pages/NoPage'
import AtlasLogin from './pages/atlasLogin/AtlasLogin'
import { RequireAtlasAuth } from './components/RequireAtlasAuth'
import { AppStateProvider } from './state/AppProvider'

import './index.css'

initializeIcons("https://res.cdn.office.net/files/fabric-cdn-prod_20241209.001/assets/icons/")

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/atlas/login" element={<AtlasLogin />} />
        <Route element={<RequireAtlasAuth />}>
          <Route
            path="/"
            element={
              <AppStateProvider>
                <Layout />
              </AppStateProvider>
            }>
            <Route index element={<Chat />} />
            <Route path="*" element={<NoPage />} />
          </Route>
        </Route>
      </Routes>
    </HashRouter>
  )
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
